import React from 'react'
import PropTypes from 'prop-types'
import { Paper, Typography, Stack, Box, alpha } from '@mui/material'

const ChartTooltip = ({ tooltip, lineColor, theme, width, height }) => {
  if (!tooltip || !width || !height) return null

  return (
    <Paper
      elevation={6}
      sx={{
        position: 'absolute',
        left: tooltip.x,
        top: tooltip.y,
        transform: 'translate(-50%, -130%)',
        p: 1.5,
        zIndex: 10,
        pointerEvents: 'none',
        minWidth: 100,
        textAlign: 'center',
        bgcolor: alpha(theme.palette.background.paper, 0.85),
        backdropFilter: 'blur(8px)',
        border: `1px solid ${alpha(lineColor, 0.3)}`,
        borderRadius: 3,
        boxShadow: `0 4px 20px ${alpha('#000', 0.1)}`,
        transition: 'left 0.08s linear, top 0.08s linear'
      }}
    >
      <Typography
        variant='caption'
        display='block'
        sx={{
          color: 'text.secondary',
          fontSize: '0.7rem',
          fontWeight: 600,
          letterSpacing: 0.5,
          mb: 0.5
        }}
      >
        {tooltip.label}
      </Typography>
      {tooltip.dateLabel
        ? (
          <Typography
            variant='caption'
            display='block'
            sx={{
              color: 'text.secondary',
              fontSize: '0.68rem',
              fontWeight: 500,
              letterSpacing: 0.3,
              mb: 0.75,
              opacity: 0.85
            }}
          >
            {tooltip.dateLabel}
          </Typography>
          )
        : null}
      <Stack direction='row' alignItems='center' justifyContent='center' spacing={0.5}>
        <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: lineColor }} />
        <Typography variant='body2' sx={{ fontWeight: 800, color: lineColor, fontSize: '1rem' }}>
          {tooltip.value}
        </Typography>
      </Stack>
    </Paper>
  )
}

ChartTooltip.propTypes = {
  tooltip: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dateLabel: PropTypes.string
  }),
  lineColor: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  width: PropTypes.number,
  height: PropTypes.number
}

export default ChartTooltip
